import { AsyncSingleSelectField, CharField, ImageField, NumberField, SwitchField } from "@inmagik/magik-ui"
import { getIn, useFormikContext } from "formik"
import { Col } from "react-bootstrap"
import { DettaglioTavola, Immagine } from "../../types"
import { WysiwygField } from "../../components/WysiwygField"
import { ImageBoxField } from "../../components/ImageBoxField"
import { useImmagineLazy, useImmaginiLazy } from "../../hooks/immagini"
import { useAtlanteLazy, useAtlantiLazy } from "../../hooks/atlanti"

export default function DettaglioTavolaForm({
  col = 8,
  hasTavola = false,
  immagine,
}: {
  col?: number
  hasTavola?: boolean
  immagine?: Immagine
}) {
  const { setFieldValue, values, errors, submitCount } = useFormikContext<DettaglioTavola>()

  // const fetchAtlante = useAtlanteLazy()
  // const fetchAtlanti = useAtlantiLazy()

  return (
    <Col xs={col} className="d-flex flex-column align-items-stretch gap-4">
      {/* {hasAtalante && <AsyncSingleSelectField
        label="Atlante"
        layout="horizontal"
        placeholder="Seleziona un atlante"
        required
        onChange={(value) => {
          setFieldValue("atlante", value)
        }}
        clearable
        value={values.atlante}
        loadOptions={(inputValue: string) => {
          return fetchAtlanti({ search: inputValue }).then((atlanti) => {
            return atlanti.results.map((atlante) => ({
              label: atlante.nome,
              value: atlante.id,
            }))
          })
        }}
        loadInitialValue={(id: number) =>
          fetchAtlante(id).then((atlante) => {
            return { label: atlante.nome, value: atlante.id }
          })
        }
        isValid={submitCount > 0 ? !getIn(errors, "atlante") : undefined}
        errorMessage={getIn(errors, "atlante")}
      ></AsyncSingleSelectField>} */}

      <CharField
        label="Titolo"
        layout="horizontal"
        value={values.titolo}
        onChange={(value) => {
          setFieldValue("titolo", value)
        }}
        isValid={submitCount > 0 ? !getIn(errors, "titolo") : undefined}
        errorMessage={getIn(errors, "titolo")}
        required
      />

      <WysiwygField
        label="Descrizione"
        layout="horizontal"
        value={values.descrizione || ""}
        onChange={(value) => {
          setFieldValue("descrizione", value)
        }}
      />

      {/* <NumberField
        label="Left"
        layout="horizontal"
        value={values.left}
        onChange={(value) => {
          setFieldValue("left", value)
        }}
        isValid={submitCount > 0 ? !getIn(errors, "left") : undefined}
        errorMessage={getIn(errors, "left")}
        
      /> */}
      {/* {immagine && (
        <ImageBoxField
          imageUrl={immagine.immagine}
          value={values}
          onChange={(value) => {
            setFieldValue("immagine", value)
          }}
          // isValid={submitCount > 0 ? !getIn(errors, "immagine") : undefined}
          // errorMessage={getIn(errors, "immagine")}
          // required
        />
      )} */}
    </Col>
  )
}
